import * as React from 'react';
import * as styles from './AssetErrorNotFound.scss';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';
import { retry } from '../assetCommands/AssetCommandDescriptors';
import AssetButton from './AssetButton';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default observer(function AssetErrorRetryable({
    errorDesc,
    retryCallback,
}: {
    errorDesc: string;
    retryCallback: () => void;
}) {
    const logAndRetryCallback = React.useCallback(() => {
        logSpacesDatapoint('OUTLOOKSPACES_ASSET_RETRYABLE_CALLBACK');
        retryCallback();
    }, [retryCallback]);

    React.useEffect(() => {
        logSpacesDatapoint('OUTLOOKSPACES_ASSET_RETRYABLE');
    }, []);

    return (
        <div className={styles.assetErrorNotFound}>
            <div className={styles.text}>
                <Icon className={styles.icon} iconName={ControlIcons.Error} />
                <span>{errorDesc}</span>
            </div>
            <AssetButton command={retry} onClick={logAndRetryCallback} />
        </div>
    );
});
